import React, { useState, useEffect, useRef } from "react";
import {
  MapContainer, TileLayer, Marker, Polyline,
  LayersControl, ZoomControl
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { fetchRoute } from "../utils/routeService";

const userIcon = new L.Icon({ iconUrl: ".../user-marker.png", iconSize: [30,30] });
const shopIcon = new L.Icon({ iconUrl: ".../shop-marker.png", iconSize: [35,35] });

const shopPos = [10.89892, 75.97625];

const Location = () => {
  const [userPos, setUserPos] = useState(null);
  const [routeCoords, setRouteCoords] = useState([]);
  const [distance, setDistance] = useState(null);
  const [duration, setDuration] = useState(null);
  const [mode, setMode] = useState("driving-car");
  const [error, setError] = useState(null);
  const mapRef = useRef();

  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Geolocation not supported.");
      return;
    }
    const id = navigator.geolocation.watchPosition(
      ({ coords }) => {
        setUserPos([coords.latitude, coords.longitude]);
        setError(null);
      },
      err => {
        setError(err.message);
        setUserPos(null);
      },
      { enableHighAccuracy: true, timeout: 15000 }
    );
    return () => navigator.geolocation.clearWatch(id);
  }, []);

  useEffect(() => {
    if (userPos) {
      fetchRoute(userPos, shopPos, mode)
        .then(({coords, dist, dur, steps}) => {
          setRouteCoords(coords);
          setDistance(dist);
          setDuration(dur);
        })
        .catch(() => setError("Could not fetch route."));
    }
  }, [userPos, mode]);

  return (
    <div className="fixed inset-0 flex flex-col">
      <header className="bg-blue-600 text-white p-3">Find Route to Sahla Curtain Center</header>
      <div className="flex-1 relative">
        <MapContainer center={shopPos} zoom={13} ref={mapRef} zoomControl={false}>
          <ZoomControl position="topright"/>
          <LayersControl position="topright">
            <LayersControl.BaseLayer checked name="Standard">
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="Satellite">
              <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="Transport">
              <TileLayer url="https://tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=YOUR_TF_API_KEY" />
            </LayersControl.BaseLayer>
          </LayersControl>
          {userPos && <Marker position={userPos} icon={userIcon} />}
          <Marker position={shopPos} icon={shopIcon} />
          {routeCoords.length>0 && <Polyline positions={routeCoords} color="blue" />}
        </MapContainer>
        <div className="absolute top-4 left-4 bg-white p-3 rounded-lg shadow-md">
          <select
            value={mode}
            onChange={e => setMode(e.target.value)}
            className="border p-1 rounded"
          >
            <option value="driving-car">Driving</option>
            <option value="foot-walking">Walking</option>
            <option value="cycling-regular">Cycling</option>
          </select>
        </div>
        <div className="absolute bottom-4 left-4 right-4 bg-white rounded-lg p-4 shadow-lg">
          {error && <p className="text-red-600">{error}</p>}
          {userPos ? (
            <>
              <p>You: {userPos[0].toFixed(5)}, {userPos[1].toFixed(5)}</p>
              <p>Distance: {(distance/1000).toFixed(2)} km</p>
              <p>ETA: {(duration/60).toFixed(1)} mins</p>
            </>
          ) : !error ? (
            <p>Locating you… please allow browser location access.</p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Location;
